export function getRoxotGroupId() {
  try {
    let storageKey = 'roxot-gid'
    let groupId = localStorage.getItem(storageKey)
    if (groupId === null) {
      groupId = 1 + Math.floor(Math.random() * 10000)
      localStorage.setItem(storageKey, groupId)
    }
    return '' + groupId
  } catch (e) {
    return '10001'
  }
}

export function getRoxotSectorId() {
  try {
    let storageKey = 'roxot-sid'
    let groupId = localStorage.getItem(storageKey)
    if (groupId === null) {
      groupId = 1 + Math.floor(Math.random() * 100)
      localStorage.setItem(storageKey, groupId)
    }
    return '' + groupId
  } catch (e) {
    return '101'
  }
}

export function getRoxotDeep() {
  try {
    let storageKey = 'roxot-deep'
    let groupId = localStorage.getItem(storageKey)
    if (groupId === null) {
      groupId = 1 + Math.floor(Math.random() * 100)
      localStorage.setItem(storageKey, groupId)
    }
    return '' + groupId
  } catch (e) {
    return '101'
  }
}

export function getRoxotEvent() {
  return '' + (1 + Math.floor(Math.random() * 100))
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/roxot.js